import { accessApi as api } from "src/datahandling/redux/api/rtkQueryCodeGen/accessApi/accessApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAccessGroupsMachine: build.query<
      GetAccessGroupsMachineApiResponse,
      GetAccessGroupsMachineApiArg
    >({
      query: () => ({ url: `/AccessGroups/machine` }),
      extraOptions: {},
    }),
    getAccessGroupsGlobalEntity: build.query<
      GetAccessGroupsGlobalEntityApiResponse,
      GetAccessGroupsGlobalEntityApiArg
    >({
      query: () => ({ url: `/AccessGroups/global/entity` }),
      extraOptions: {},
    }),
    getAccessGroupsGlobalRole: build.query<
      GetAccessGroupsGlobalRoleApiResponse,
      GetAccessGroupsGlobalRoleApiArg
    >({
      query: () => ({ url: `/AccessGroups/global/role` }),
      extraOptions: {},
    }),
    getAccessGroupsAreasRoles: build.query<
      GetAccessGroupsAreasRolesApiResponse,
      GetAccessGroupsAreasRolesApiArg
    >({
      query: () => ({ url: `/AccessGroups/areas/roles` }),
      extraOptions: {},
    }),
    getAccessGroupsAreasEntities: build.query<
      GetAccessGroupsAreasEntitiesApiResponse,
      GetAccessGroupsAreasEntitiesApiArg
    >({
      query: () => ({ url: `/AccessGroups/areas/entities` }),
      extraOptions: {},
    }),
    getAccessGroupsCompanyCompanyId: build.query<
      GetAccessGroupsCompanyCompanyIdApiResponse,
      GetAccessGroupsCompanyCompanyIdApiArg
    >({
      query: (queryArg) => ({
        url: `/AccessGroups/company/${queryArg.companyId}`,
      }),
      extraOptions: {},
    }),
    getAccessGroupsCompanyAll: build.query<
      GetAccessGroupsCompanyAllApiResponse,
      GetAccessGroupsCompanyAllApiArg
    >({
      query: () => ({ url: `/AccessGroups/company/all` }),
      extraOptions: {},
    }),
    postAccessGroups: build.mutation<
      PostAccessGroupsApiResponse,
      PostAccessGroupsApiArg
    >({
      query: (queryArg) => ({
        url: `/AccessGroups`,
        method: "POST",
        body: queryArg.accessGroupWeb,
      }),
      extraOptions: {},
    }),
    deleteAccessGroupsGroupAccessGroupId: build.mutation<
      DeleteAccessGroupsGroupAccessGroupIdApiResponse,
      DeleteAccessGroupsGroupAccessGroupIdApiArg
    >({
      query: (queryArg) => ({
        url: `/AccessGroups/group/${queryArg.accessGroupId}`,
        method: "DELETE",
      }),
      extraOptions: {},
    }),
    postB2CRedeem: build.mutation<
      PostB2CRedeemApiResponse,
      PostB2CRedeemApiArg
    >({
      query: (queryArg) => ({
        url: `/B2C/redeem`,
        method: "POST",
        body: queryArg.redeemUserAccessDtoWeb,
      }),
      extraOptions: {},
    }),
    postInvitation: build.mutation<
      PostInvitationApiResponse,
      PostInvitationApiArg
    >({
      query: (queryArg) => ({
        url: `/Invitation`,
        method: "POST",
        body: queryArg.inviteUsersDtoWeb,
      }),
      extraOptions: {},
    }),
    postInvitationUserId: build.mutation<
      PostInvitationUserIdApiResponse,
      PostInvitationUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/Invitation/${queryArg.userId}`,
        method: "POST",
        body: queryArg.acceptInvitationDtoWeb,
      }),
      extraOptions: {},
    }),
    getRoles: build.query<GetRolesApiResponse, GetRolesApiArg>({
      query: () => ({ url: `/Roles` }),
      extraOptions: {},
    }),
    getSiteAccessSiteIdRollback: build.query<
      GetSiteAccessSiteIdRollbackApiResponse,
      GetSiteAccessSiteIdRollbackApiArg
    >({
      query: (queryArg) => ({ url: `/SiteAccess/${queryArg.siteId}/rollback` }),
      extraOptions: {},
    }),
    postSiteAccessSiteIdRollback: build.mutation<
      PostSiteAccessSiteIdRollbackApiResponse,
      PostSiteAccessSiteIdRollbackApiArg
    >({
      query: (queryArg) => ({
        url: `/SiteAccess/${queryArg.siteId}/rollback`,
        method: "POST",
        body: queryArg.body,
      }),
      extraOptions: {},
    }),
    deleteSiteAccessSiteId: build.mutation<
      DeleteSiteAccessSiteIdApiResponse,
      DeleteSiteAccessSiteIdApiArg
    >({
      query: (queryArg) => ({
        url: `/SiteAccess/${queryArg.siteId}`,
        method: "DELETE",
      }),
      extraOptions: {},
    }),
    getUserAccessMe: build.query<
      GetUserAccessMeApiResponse,
      GetUserAccessMeApiArg
    >({
      query: (queryArg) => ({
        url: `/UserAccess/me`,
        params: {
          ignoreCache: queryArg.ignoreCache,
          includeDisabled: queryArg.includeDisabled,
        },
      }),
      extraOptions: {},
    }),
    getUserAccess: build.query<GetUserAccessApiResponse, GetUserAccessApiArg>({
      query: (queryArg) => ({
        url: `/UserAccess`,
        params: {
          ignoreCache: queryArg.ignoreCache,
          includeDisabled: queryArg.includeDisabled,
        },
      }),
      extraOptions: {},
    }),
    deleteUserAccess: build.mutation<
      DeleteUserAccessApiResponse,
      DeleteUserAccessApiArg
    >({
      query: (queryArg) => ({
        url: `/UserAccess`,
        method: "DELETE",
        params: {
          userIds: queryArg.userIds,
        },
      }),
      extraOptions: {},
    }),
    getUserAccessAll: build.query<
      GetUserAccessAllApiResponse,
      GetUserAccessAllApiArg
    >({
      query: (queryArg) => ({
        url: `/UserAccess/all`,
        params: {
          includeDisabled: queryArg.includeDisabled,
          ignoreCache: queryArg.ignoreCache,
        },
      }),
      extraOptions: {},
    }),
    getUserAccessUserIdCompanyCompanyId: build.query<
      GetUserAccessUserIdCompanyCompanyIdApiResponse,
      GetUserAccessUserIdCompanyCompanyIdApiArg
    >({
      query: (queryArg) => ({
        url: `/UserAccess/${queryArg.userId}/company/${queryArg.companyId}`,
        params: {
          includeDisabled: queryArg.includeDisabled,
          ignoreCache: queryArg.ignoreCache,
          ignoreGosEntities: queryArg.ignoreGosEntities,
        },
      }),
      extraOptions: {},
    }),
    postUserAccessUserIdCompanyCompanyId: build.mutation<
      PostUserAccessUserIdCompanyCompanyIdApiResponse,
      PostUserAccessUserIdCompanyCompanyIdApiArg
    >({
      query: (queryArg) => ({
        url: `/UserAccess/${queryArg.userId}/company/${queryArg.companyId}`,
        method: "POST",
        body: queryArg.userAccessWeb,
      }),
      extraOptions: {},
    }),
    deleteUserAccessUserIdCompanyCompanyId: build.mutation<
      DeleteUserAccessUserIdCompanyCompanyIdApiResponse,
      DeleteUserAccessUserIdCompanyCompanyIdApiArg
    >({
      query: (queryArg) => ({
        url: `/UserAccess/${queryArg.userId}/company/${queryArg.companyId}`,
        method: "DELETE",
      }),
      extraOptions: {},
    }),
    getUserAccessUserId: build.query<
      GetUserAccessUserIdApiResponse,
      GetUserAccessUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/UserAccess/${queryArg.userId}`,
        params: {
          includeDisabled: queryArg.includeDisabled,
          ignoreCache: queryArg.ignoreCache,
          ignoreGosEntities: queryArg.ignoreGosEntities,
        },
      }),
      extraOptions: {},
    }),
    postUserAccessUserId: build.mutation<
      PostUserAccessUserIdApiResponse,
      PostUserAccessUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/UserAccess/${queryArg.userId}`,
        method: "POST",
        body: queryArg.userAccessWeb,
      }),
      extraOptions: {},
    }),
    deleteUserAccessUserId: build.mutation<
      DeleteUserAccessUserIdApiResponse,
      DeleteUserAccessUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/UserAccess/${queryArg.userId}`,
        method: "DELETE",
      }),
      extraOptions: {},
    }),
    postUserAccessUserIdCompanyCompanyIdRoles: build.mutation<
      PostUserAccessUserIdCompanyCompanyIdRolesApiResponse,
      PostUserAccessUserIdCompanyCompanyIdRolesApiArg
    >({
      query: (queryArg) => ({
        url: `/UserAccess/${queryArg.userId}/company/${queryArg.companyId}/roles`,
        method: "POST",
        body: queryArg.postCompanyRolesDtoWeb,
      }),
      extraOptions: {},
    }),
    postUserAccessCompanyCompanyId: build.mutation<
      PostUserAccessCompanyCompanyIdApiResponse,
      PostUserAccessCompanyCompanyIdApiArg
    >({
      query: (queryArg) => ({
        url: `/UserAccess/company/${queryArg.companyId}`,
        method: "POST",
        body: queryArg.body,
      }),
      extraOptions: {},
    }),
    putUserAccessRedeem: build.mutation<
      PutUserAccessRedeemApiResponse,
      PutUserAccessRedeemApiArg
    >({
      query: (queryArg) => ({
        url: `/UserAccess/redeem`,
        method: "PUT",
        body: queryArg.redeemUserAccessDtoWeb,
      }),
      extraOptions: {},
    }),

  }),
  overrideExisting: false,
});
export { injectedRtkApi as accessApi };
export type GetAccessGroupsMachineApiResponse =
  /** status 200 OK */ AccessGroupWeb[];
export type GetAccessGroupsMachineApiArg = void;
export type GetAccessGroupsGlobalEntityApiResponse =
  /** status 200 OK */ AccessGroupWeb[];
export type GetAccessGroupsGlobalEntityApiArg = void;
export type GetAccessGroupsGlobalRoleApiResponse =
  /** status 200 OK */ AccessGroupWeb[];
export type GetAccessGroupsGlobalRoleApiArg = void;
export type GetAccessGroupsAreasRolesApiResponse =
  /** status 200 OK */ AccessAreaWeb[];
export type GetAccessGroupsAreasRolesApiArg = void;
export type GetAccessGroupsAreasEntitiesApiResponse =
  /** status 200 OK */ AccessAreaWeb[];
export type GetAccessGroupsAreasEntitiesApiArg = void;
export type GetAccessGroupsCompanyCompanyIdApiResponse =
  /** status 200 OK */ AccessGroupWeb[];
export type GetAccessGroupsCompanyCompanyIdApiArg = {
  companyId: string;
};
export type GetAccessGroupsCompanyAllApiResponse =
  /** status 200 OK */ AccessGroupWeb[];
export type GetAccessGroupsCompanyAllApiArg = void;
export type PostAccessGroupsApiResponse = /** status 200 OK */ number;
export type PostAccessGroupsApiArg = {
  accessGroupWeb: AccessGroupWeb;
};
export type DeleteAccessGroupsGroupAccessGroupIdApiResponse =
  /** status 200 OK */ number;
export type DeleteAccessGroupsGroupAccessGroupIdApiArg = {
  accessGroupId: number;
};
export type PostB2CRedeemApiResponse = unknown;
export type PostB2CRedeemApiArg = {
  redeemUserAccessDtoWeb: RedeemUserAccessDtoWeb;
};
export type PostInvitationApiResponse = unknown;
export type PostInvitationApiArg = {
  inviteUsersDtoWeb: InviteUsersDtoWeb;
};
export type PostInvitationUserIdApiResponse = unknown;
export type PostInvitationUserIdApiArg = {
  userId: string;
  acceptInvitationDtoWeb: AcceptInvitationDtoWeb;
};
export type GetRolesApiResponse = /** status 200 OK */ UserRoleWeb[];
export type GetRolesApiArg = void;
export type GetSiteAccessSiteIdRollbackApiResponse =
  /** status 200 OK */ SiteAccessRollbackDtoWeb[];
export type GetSiteAccessSiteIdRollbackApiArg = {
  siteId: number;
};
export type PostSiteAccessSiteIdRollbackApiResponse =
  /** status 200 OK */ number;
export type PostSiteAccessSiteIdRollbackApiArg = {
  siteId: string;
  body: SiteAccessRollbackDtoWeb[];
};
export type DeleteSiteAccessSiteIdApiResponse = /** status 200 OK */ number;
export type DeleteSiteAccessSiteIdApiArg = {
  siteId: number;
};
export type GetUserAccessMeApiResponse = /** status 200 OK */ UserAccessWeb;
export type GetUserAccessMeApiArg = {
  ignoreCache?: boolean;
  includeDisabled?: boolean;
};
export type GetUserAccessApiResponse = /** status 200 OK */ UserAccessWeb[];
export type GetUserAccessApiArg = {
  ignoreCache?: boolean;
  includeDisabled?: boolean;
};
export type DeleteUserAccessApiResponse = unknown;
export type DeleteUserAccessApiArg = {
  userIds?: string[];
};
export type GetUserAccessAllApiResponse = /** status 200 OK */ UserAccessWeb[];
export type GetUserAccessAllApiArg = {
  includeDisabled?: boolean;
  ignoreCache?: boolean;
};
export type GetUserAccessUserIdCompanyCompanyIdApiResponse =
  /** status 200 OK */ UserAccessWeb;
export type GetUserAccessUserIdCompanyCompanyIdApiArg = {
  userId: string;
  companyId: string;
  includeDisabled?: boolean;
  ignoreCache?: boolean;
  ignoreGosEntities?: boolean;
};
export type PostUserAccessUserIdCompanyCompanyIdApiResponse =
  /** status 200 OK */ number;
export type PostUserAccessUserIdCompanyCompanyIdApiArg = {
  userId: string;
  companyId: string;
  userAccessWeb: UserAccessWeb;
};
export type DeleteUserAccessUserIdCompanyCompanyIdApiResponse = unknown;
export type DeleteUserAccessUserIdCompanyCompanyIdApiArg = {
  userId: string;
  companyId: string;
};
export type GetUserAccessUserIdApiResponse = /** status 200 OK */ UserAccessWeb;
export type GetUserAccessUserIdApiArg = {
  userId: string;
  includeDisabled?: boolean;
  ignoreCache?: boolean;
  ignoreGosEntities?: boolean;
};
export type PostUserAccessUserIdApiResponse = /** status 200 OK */ number;
export type PostUserAccessUserIdApiArg = {
  userId: string;
  userAccessWeb: UserAccessWeb;
};
export type DeleteUserAccessUserIdApiResponse = unknown;
export type DeleteUserAccessUserIdApiArg = {
  userId: string;
};
export type PostUserAccessUserIdCompanyCompanyIdRolesApiResponse =
  /** status 200 OK */ number;
export type PostUserAccessUserIdCompanyCompanyIdRolesApiArg = {
  userId: string;
  companyId: string;
  postCompanyRolesDtoWeb: PostCompanyRolesDtoWeb;
};
export type PostUserAccessCompanyCompanyIdApiResponse = unknown;
export type PostUserAccessCompanyCompanyIdApiArg = {
  companyId: string;
  body: UserAccessWeb[];
};
export type PutUserAccessRedeemApiResponse = unknown;
export type PutUserAccessRedeemApiArg = {
  redeemUserAccessDtoWeb: RedeemUserAccessDtoWeb;
};
export type AccessType = "Entity" | "Role" | "Machine";
export type AccessLevel = "NoAccess" | "Read" | "Write" | "Admin";
export type AccessAreaWeb = {
  id?: number;
  areaName?: string | null;
  displayName?: string | null;
  accessLevel?: AccessLevel;
  accessType?: AccessType;
};
export type AccessGroupWeb = {
  id?: number;
  companyGosId?: string | null;
  accessGroupName?: string | null;
  accessGroupDescription?: string | null;
  accessType?: AccessType;
  accessAreas?: AccessAreaWeb[] | null;
};
export type RedeemUserAccessDtoWeb = {
  email?: string | null;
  identityProvider?: string | null;
  userId?: string | null;
};
export type UnitAccessWeb = {
  gosId?: number;
};
export type SiloAccessWeb = {
  gosId?: number;
};
export type BargeAccessWeb = {
  gosId?: number;
  silos?: SiloAccessWeb[] | null;
};
export type SiteAccessWeb = {
  gosId?: number;
  name?: string | null;
  companyId?: string | null;
  companyName?: string | null;
  accessGroups?: AccessGroupWeb[] | null;
  unitAccesses?: UnitAccessWeb[] | null;
  bargeAccesses?: BargeAccessWeb[] | null;
};
export type EntityGroupAccessWeb = {
  groupName?: string | null;
  companyGosId?: string | null;
  companyName?: string | null;
  levelName?: string | null;
  gosId?: number;
  parentGosId?: number | null;
  children?: EntityGroupAccessWeb[] | null;
  sites?: SiteAccessWeb[] | null;
  accessGroups?: AccessGroupWeb[] | null;
};
export type CompanyAccessWeb = {
  gosId?: string | null;
  name?: string | null;
  suspended?: boolean;
  accessGroups?: AccessGroupWeb[] | null;
  sites?: SiteAccessWeb[] | null;
  entityGroups?: EntityGroupAccessWeb[] | null;
};
export type UserRoleWeb = {
  id?: number;
  name?: string | null;
};
export type InviteUsersDtoWeb = {
  userEmails?: string[] | null;
  companyAccess?: CompanyAccessWeb;
  role?: UserRoleWeb;
};
export type AcceptInvitationDtoWeb = {
  companyIds?: string[] | null;
};
export type EntityGroupAccessData = {
  id?: number;
  groupGosId?: number;
  companyGosId?: string | null;
  groupName?: string | null;
  levelName?: string | null;
  accessGroups?: AccessGroupData[] | null;
  companyAccess?: CompanyAccessData;
  createdOn?: string;
  updatedOn?: string;
};
export type AccessAreaData = {
  areaName?: string | null;
  displayName?: string | null;
  accessLevel?: AccessLevel;
  accessType?: AccessType;
  accessGroups?: AccessGroupData[] | null;
  id?: number;
  createdOn?: string;
  updatedOn?: string;
};
export type AccessGroupData = {
  companyGOSId?: string | null;
  accessGroupName?: string | null;
  accessGroupDescription?: string | null;
  accessType?: AccessType;
  siteAccesses?: SiteAccessData[] | null;
  entityGroups?: EntityGroupAccessData[] | null;
  companyAccesses?: CompanyAccessData[] | null;
  accessAreas?: AccessAreaData[] | null;
  id?: number;
  createdOn?: string;
  updatedOn?: string;
};
export type CompanyAccessData = {
  id?: number;
  companyGosId?: string | null;
  name?: string | null;
  suspended?: boolean;
  accessGroups?: AccessGroupData[] | null;
  sites?: SiteAccessData[] | null;
  entityGroups?: EntityGroupAccessData[] | null;
  createdOn?: string;
  updatedOn?: string;
};
export type SiteAccessData = {
  id?: number;
  siteGOSId?: number;
  companyAccessDataId?: number;
  companyAccess?: CompanyAccessData;
  accessGroups?: AccessGroupData[] | null;
  createdOn?: string;
  updatedOn?: string;
};
export type SiteAccessRollbackDtoWeb = {
  siteAccessData?: SiteAccessData;
  companyGosId?: string | null;
  userId?: string | null;
};
export type UserAccessWeb = {
  userId?: string | null;
  userIdType?: string | null;
  role?: UserRoleWeb;
  companyAccesses?: CompanyAccessWeb[] | null;
};
export type WebError = {
  message?: string | null;
  code?: string | null;
  details?: any | null;
  originalError?: WebError;
};
export type WebErrorRead = {
  message?: string | null;
  code?: string | null;
  details?: any | null;
  disclaimer?: string | null;
  originalError?: WebErrorRead;
  traceId?: string | null;
};
export type PostCompanyRolesDtoWeb = {
  userId?: string | null;
  companyId?: string | null;
  companyName?: string | null;
  accessGroups?: AccessGroupWeb[] | null;
};
export const {
  useGetAccessGroupsMachineQuery,
  useGetAccessGroupsGlobalEntityQuery,
  useGetAccessGroupsGlobalRoleQuery,
  useGetAccessGroupsAreasRolesQuery,
  useGetAccessGroupsAreasEntitiesQuery,
  useGetAccessGroupsCompanyCompanyIdQuery,
  useGetAccessGroupsCompanyAllQuery,
  usePostAccessGroupsMutation,
  useDeleteAccessGroupsGroupAccessGroupIdMutation,
  usePostB2CRedeemMutation,
  usePostInvitationMutation,
  usePostInvitationUserIdMutation,
  useGetRolesQuery,
  useGetSiteAccessSiteIdRollbackQuery,
  usePostSiteAccessSiteIdRollbackMutation,
  useDeleteSiteAccessSiteIdMutation,
  useGetUserAccessMeQuery,
  useGetUserAccessQuery,
  useDeleteUserAccessMutation,
  useGetUserAccessAllQuery,
  useGetUserAccessUserIdCompanyCompanyIdQuery,
  usePostUserAccessUserIdCompanyCompanyIdMutation,
  useDeleteUserAccessUserIdCompanyCompanyIdMutation,
  useGetUserAccessUserIdQuery,
  usePostUserAccessUserIdMutation,
  useDeleteUserAccessUserIdMutation,
  usePostUserAccessUserIdCompanyCompanyIdRolesMutation,
  usePostUserAccessCompanyCompanyIdMutation,
  usePutUserAccessRedeemMutation,
} = injectedRtkApi;

import { accessApi } from "./accessApi";
export type accessApiType = typeof accessApi;
